<template>
  <div
    :class="{
      'group/author flex items-center gap-10px': true,
    }"
  >
    <PtcPicture
      v-if="headshot.asset"
      provider="sanity"
      format="webp"
      :src="headshot.asset?._ref"
      :alt="resolvedImage?.altText || 'author headshot'"
      :img-attrs="{
        class: {
          'h-30px w-30px rounded-full object-cover object-center group-hover:animate-flash ease-out': true,
        },
      }"
      :modifiers="{
        crop: headshot?.crop,
        hotspot: headshot?.hotspot,
      }"
      loading="lazy"
    />

    <div
      :class="{
        'author_name text-xs text-www-color-neutral-medium-dark hover:text-www-color-primary-lighter group-hover/author:underline': true,
      }"
    >
      {{ name }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Person } from '~/sanity/types';

const props = defineProps<Person>();
const { getResolvedImage } = useRefsStore();
const resolvedImage = await getResolvedImage(props.headshot?.asset?._ref);
</script>
